import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { comingSoon } from "@/lib/site";
import { CALENDLY_URL } from "@/data/nav";

const STYLES = {
  primary: "bg-white text-[#0B0716] hover:bg-violet-200",
  violet: "bg-violet-600 text-white hover:bg-violet-500",
  ghost: "border border-white/25 text-white hover:border-violet-300 hover:bg-white/5",
  dark: "bg-[#0B0716] text-white hover:bg-violet-700",
  outline: "border border-slate-300 text-slate-900 hover:border-violet-600 hover:text-violet-700",
};

export const CtaButton = ({ label, variant = "primary", to, href, soon, testid, className = "", size = "md" }) => {
  const pad = size === "sm" ? "h-10 px-5 text-[13px]" : "h-12 sm:h-14 px-6 sm:px-7 text-sm sm:text-[15px]";
  const cls = `btn-shine group inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-[background-color,border-color,color,transform] duration-300 hover:-translate-y-0.5 ${pad} ${STYLES[variant]} ${className}`;
  const inner = (
    <>
      <span>{label}</span>
      <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:rotate-45" />
    </>
  );
  if (to) return <Link to={to} data-testid={testid} className={cls}>{inner}</Link>;
  if (href) return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={cls}>{inner}</a>;
  if (!soon) return <Link to="/contact" data-testid={testid} className={cls}>{inner}</Link>;
  return (
    <button type="button" data-testid={testid} className={cls} onClick={() => comingSoon(soon)}>
      {inner}
    </button>
  );
};

export const BookMeeting = ({ variant, testid, className, size }) => (
  <CtaButton label="Book a Meeting" href={CALENDLY_URL} variant={variant} testid={testid} className={className} size={size} />
);

export const CtaRow = ({ children, className = "" }) => (
  <div className={`flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center ${className}`}>{children}</div>
);
